import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PopupStatusRes;
export const PopupStatusTodo = createAsyncThunk('PopupStatus', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "PUT",
            url: process.env.REACT_APP_API_URL + `update_popup_status/${data.id}`,
            params:{
                "popup_status" : data.status
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return PopupStatusRes = res.data

    } catch (error) {
        return PopupStatusRes = error.response.data
    }
})